export const SALES_ORDER_PAGE_TITLE = "Đơn bán hàng / Xuất kho";

export const FORM_IDS = {
  CREATE: "create-sales-order-form",
};
